import { render, staticRenderFns } from "./RxSnackbar.vue?vue&type=template&id=8db40e70"
import script from "./RxSnackbar.vue?vue&type=script&lang=js"
export * from "./RxSnackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports